import { registerDecorator, ValidationArguments } from 'class-validator';

import { translateErrorKey } from '../i18n/request-translate';

import { TI18nValidationOptions } from './class.validators';

const allowedSymRegexp = /^[a-zA-Z0-9 _-]+$/;
const onlyDigitsRegexp = /^[0-9]+$/;
const onlySpaceRegexp = /^[ ]+$/;

export function CustomValidateName(validationOptions?: TI18nValidationOptions) {
  return function (object: Record<string, any>, propertyName: string) {
    registerDecorator({
      name: 'CustomValidateName',
      target: object.constructor,
      propertyName: propertyName,
      options: {
        ...validationOptions,
        groups: validationOptions?.groups || ['error'],
      },
      validator: {
        validate(value: string) {
          return (
            value.length >= 3 &&
            value.length <= 30 &&
            allowedSymRegexp.test(value) &&
            !onlyDigitsRegexp.test(value) &&
            !onlySpaceRegexp.test(value)
          );
        },
        defaultMessage() {
          return translateErrorKey('validation.customValidateName');
        },
      },
    });
  };
}

const lettersRegexp = /[A-Za-z]/;
const digitRegexp = /[0-9]/;

export function CustomValidatePassword(
  validationOptions?: TI18nValidationOptions,
) {
  return function (object: Record<string, any>, propertyName: string) {
    registerDecorator({
      name: 'CustomValidatePassword',
      target: object.constructor,
      propertyName: propertyName,
      options: {
        ...validationOptions,
        groups: validationOptions?.groups || ['error'],
      },
      validator: {
        validate(value: string) {
          return (
            value.length >= 5 &&
            lettersRegexp.test(value) &&
            digitRegexp.test(value)
          );
        },
        defaultMessage() {
          return translateErrorKey('validation.customValidatePassword');
        },
      },
    });
  };
}

export function IsEqualTo(
  property: string,
  validationOptions?: TI18nValidationOptions,
) {
  return (object: Record<string, any>, propertyName: string) => {
    registerDecorator({
      name: 'isEqualTo',
      target: object.constructor,
      propertyName,
      constraints: [property],
      options: {
        ...validationOptions,
        groups: validationOptions?.groups || ['error'],
      },
      validator: {
        validate(value: unknown, args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints;
          const relatedValue = (args.object as Record<string, unknown>)[
            relatedPropertyName
          ];
          return value === relatedValue;
        },

        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints;
          return translateErrorKey('custom.passwordEqual', {
            property: args.property,
            relatedProperty: relatedPropertyName,
          });
        },
      },
    });
  };
}
